export default "__VITE_ASSET__PNcM7QX6__"